import http from "../../BaseTilelyticsApiHttp";

class DashboardService {
  getProductionUnitSummary(requestData) {
    return http.post(`v2/production-units/downtimes-summary`, requestData);
  }

  getPerformanceLossBlocks(requestData) {
    const factoryId = requestData.factory_id;
    let puIdsQuery = "";
    if (requestData.production_unit_ids) {
      let puIdsParam;
      if (requestData.production_unit_ids instanceof Array) {
        puIdsParam = requestData.production_unit_ids.join(",");
      } else {
        puIdsParam = requestData.production_unit_ids;
      }
      puIdsQuery = `&production_unit_ids=${puIdsParam}`;
    }
    const startParam = encodeURIComponent(requestData.start_date);
    const endParam = encodeURIComponent(requestData.end_date);
    const queryParams = `start_date=${startParam}&end_date=${endParam}${puIdsQuery}`;

    return http.get(`factories/${factoryId}/performance-loss-blocks?${queryParams}`);
  }
}

export default new DashboardService();
